import { render, staticRenderFns } from "./join_3.vue?vue&type=template&id=4b635e8c&scoped=true"
import script from "./join_3.vue?vue&type=script&lang=js"
export * from "./join_3.vue?vue&type=script&lang=js"
import style0 from "./join_3.vue?vue&type=style&index=0&id=4b635e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b635e8c",
  null
  
)

export default component.exports